/**
 * IMPORTS
 */
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleListarMinhaAgenda } from "@/domain/use-cases/agenda-cliente";
import type { IFiltrosMinhaAgenda } from "@/interface/agenda-cliente";
import { FEATURES, useFeature } from "@/utils/auth/features";

const AGENDA_QUERY_KEY = "agenda-cliente";

/** Compromissos visíveis ao cliente, paginados (a API ordena por data, mais próximos primeiro). */
function useMinhaAgenda(filtros: IFiltrosMinhaAgenda) {
  const accessToken = useStoreZustandUserAuth((state) => state.token);
  const habilitado = useFeature(FEATURES.ACESSAR_AGENDA_CLIENTE);

  return useQuery({
    queryKey: [AGENDA_QUERY_KEY, filtros],
    queryFn: () => handleListarMinhaAgenda(accessToken!, filtros),
    enabled: Boolean(accessToken && habilitado),
    placeholderData: keepPreviousData,
  });
}

/**
 * EXPORTS
 */
export { AGENDA_QUERY_KEY, useMinhaAgenda };
